<template>
  <div>
    <detail-layout ref="layout" :tableCfg="tableCfg">
      <template slot="FormLayout" scope="props">
        <b-form ref="form" class="offset-md-1" autocomplete="off">
          <div v-if="dataValid" >
            <div class="row">
              <detail-field v-if="!isPlanned" class="col-md-6" label="Invoice Number" field="number" :rec="props.rec" :isReadOnly="isReadOnly || isLocked()" vvalidate="ok" :validator="validator"/>
              <detail-field v-if="isPlanned && !isNew" class="col-md-6" label="Reference" field="document_reference" :rec="props.rec" :isReadOnly="true" vvalidate="ok" :validator="validator"/>
              <detail-field class="col-md-6" label="Contract/Student" field="contract_id" :optionListApiUrl="'/contracts/choice/'" :rec="props.rec" :isReadOnly="!isNew" vvalidate="required" :validator="validator"/>
              <detail-field class="col-md-6" label="Year" field="year" :rec="props.rec" :isReadOnly="!isNew" vvalidate="required" :validator="validator"/>
              <detail-field class="col-md-6" label="Semester" field="semester" :rec="props.rec" :isReadOnly="!isNew" vvalidate="required" :validator="validator"/>
              <detail-field class="col-md-6" label="Description" field="description" :rec="props.rec" :isReadOnly="isReadOnly || (isEdit && !isPlanned)" vvalidate="required" :validator="validator"/>
              <detail-field class="col-md-6" label="Linked to" field="linked_invoice_number" :rec="props.rec" :isReadOnly="true" vvalidate="ok" :validator="validator"/>
            </div>
            <div class="row">
              <detail-field v-if="!isPlanned" class="col-md-6" label="Invoice Date" field="invoice_date" :rec="props.rec" :isReadOnly="isReadOnly || isLocked()" type="date" vvalidate="ok" :validator="validator"/>
              <detail-field class="col-md-6" label="Planned Date" field="planned_date" :rec="props.rec" :isReadOnly="isReadOnly || isLocked()" type="date" :vvalidate="isPlanned ? 'required' :'ok'" :validator="validator"/>
              <detail-field v-if="!isPlanned" class="col-md-6" label="Expiration Date" field="expiration_date" :rec="props.rec" :isReadOnly="isReadOnly  || isLocked()" type="date" vvalidate="ok" :validator="validator"/>
              <detail-field v-if="!isPlanned" class="col-md-6" label="Extended Deadline Date" field="extended_deadline_date" :rec="props.rec" :isReadOnly="isReadOnly" type="date" vvalidate="ok" :validator="validator"/>
              <detail-field class="col-md-6" label="Amount to be paid" field="amount" :rec="props.rec" :isReadOnly="isReadOnly || isLocked()" type="money" vvalidate="required" :validator="validator"/>
              <detail-field v-if="isReadOnly" class="col-md-6" label="Amount invoiced" field="total_amount" :rec="props.rec" :isReadOnly="true" type="money" vvalidate="ok" :validator="validator"/>
            </div>
            <div class="row" v-if="!isNew">
              <detail-field v-if="!isPlanned" class="col-md-6" label="Amount paid" field="payed_amount" :rec="props.rec" :isReadOnly="true" type="money" vvalidate="ok" :validator="validator"/>
            </div>
            <div class="row">
              <detail-field class="col-md-6" label="Comments" field="comments" type="textarea" :rec="props.rec" :isReadOnly="isReadOnly" vvalidate="ok" :validator="validator"/>
              <detail-field v-if="!isPlanned" class="col-md-6" label="Pro Forma" field="pro_forma" :rec="props.rec" :isReadOnly="true" type="boolean" vvalidate="ok" :validator="validator"/>
            </div>
            <div class="row" v-if="!isNew">
              <detail-field class="col-md-6" label="Created" field="creation_timestamp" field2="creation_user" :static="true" :rec="props.rec" :isReadOnly="true" type="timestamp_user" vvalidate="ok" :validator="validator"/>
              <detail-field class="col-md-6" label="Last Edit" field="edit_timestamp" field2="edit_user" :static="true" :rec="props.rec" :isReadOnly="true" type="timestamp_user" vvalidate="ok" :validator="validator"/>
              <detail-field v-if="!isPlanned" class="col-md-6" label="PDF Creation" field="pdf_creation_timestamp" field2="pdf_creation_user" :static="true" :rec="props.rec" :isReadOnly="true" type="timestamp_user" vvalidate="ok" :validator="validator"/>
              <detail-field v-if="!isPlanned" class="col-md-6" label="Email" field="email_timestamp" field2="email_user" :static="true" :rec="props.rec" :isReadOnly="true" type="timestamp_user" vvalidate="ok" :validator="validator"/>
            </div>
          </div>
        </b-form>
      </template>
      <template slot="ExtraOptions" scope="props">
          <b-dropdown variant="default" size="sm">
            <template slot="button-content"> <i class="fa fa-cog"></i> </template>
            <b-dropdown-item v-if="isPlanned && privUser" @click="createPDF(props.rec)">Create Invoice</b-dropdown-item>
            <b-dropdown-item v-if="!isPlanned" @click="downloadPDF(props.rec)">Download {{isCreditNote ? 'Credit Note' : 'Invoice'}}</b-dropdown-item>
            <b-dropdown-item v-if="(isNumbered || isCreditNote) && (props.rec.is_creditnote === false) && !props.rec.is_expired && privUser" @click="sendEmail(props.rec,false)">Send Email</b-dropdown-item>
            <b-dropdown-item v-if="isNumbered && props.rec.document_type_id === 1 && props.rec.is_expired && privUser" @click="sendEmail(props.rec,true)">Send Email Reminder</b-dropdown-item>
            <b-dropdown-item v-if="isNumbered && privUser" @click="createCreditNote(props.rec)">{{getCancelCommand(props.rec) }}</b-dropdown-item>
          </b-dropdown>
      </template>
    </detail-layout>
    <b-modal ref="modalCreditNote" size="lg" title="CreditNote" @ok="okCreditNote">
      <b-form ref="cnform" class="col-md-8 offset-md-1" autocomplete="off">
        <detail-field label="Amount" field="amount" :rec="cnRec" :isReadOnly="false" vvalidate="required" :validator="validator"/>
        <detail-field label="Description" field="description" :rec="cnRec" :isReadOnly="false" vvalidate="required" :validator="validator"/>
      </b-form>
    </b-modal>
    <b-modal ref="modalLinkRegistrationFee" size="lg" title="Link Registration Fee" ok-title="Link" @ok="okLinkRegistrationFee">
      <b-form ref="lrfform" class="col-md-8 offset-md-1" autocomplete="off">
        <detail-field ref="lfrOptionList" class="col-md-12" label="Registration Fee" field="registration_id" :optionListApiUrl="'/invoices/choice/'" :optionListApiDoUpdate="false" :rec="lrfRec" :isReadOnly="false" vvalidate="required" :validator="validator"/>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
import api from '../../api'
import DetailMixin from '../../components/DetailMixin'
import FieldDefs from './FieldDefs.js'

export default {
  name: 'invoice_detail',
  mixins: [DetailMixin],
  data () {
    return {
      tableCfg: FieldDefs,
      cnRec: {amount: 0, description: ''},
      lrfRec: {}
    }
  },
  computed: {
    isPlanned () { return this.tableCfg.subType(this) === 'planned' },
    isNumbered () { return this.tableCfg.subType(this) === 'numbered' },
    isCreditNote () { return this.tableCfg.subType(this) === 'creditnote' }
    // rec () { return this.$refs.layout ? this.$refs.layout.rec : {} },
    // isInvoice () { return this.rec.document_type_id === 1 },
  },
  methods: {
    isLocked () { return this.$refs.layout && this.$refs.layout.rec && this.$refs.layout.rec.is_locked },
    createPDF (rec) {
      // console.log(rec)
      api.post('/invoices/' + rec.id + '/create_pdf', {},
      data => {
        // console.log(data)
        // this.rec = data
      },
      'creating pdf', this.$refs.layout.$refs.alert)
    },
    downloadPDF (rec) {
      // console.log(rec)
      api.downloadPost('/invoices/' + rec.id + '/download_pdf', {}, rec.pdf_filename)
    },
    getCancelCommand (rec) {
      var cmd = 'Create Credit Note'
      if ((rec.document_type_id !== 1) && rec.pro_forma) {
        cmd = 'Cancel Registration'
      }
      return cmd
    },
    sendEmail (rec, reminder) {
      // console.log(rec)
      api.post('/invoices/' + rec.id + '/send_email', {reminder: reminder},
      data => {
        // console.log(data)
        // this.rec = data
      },
      'sending email', this.$refs.layout.$refs.alert)
    },
    createCreditNote (rec) {
      this.cnRec.linked_invoice_id = rec.linked_invoice_id
      this.cnRec.cn_invoice_id = rec.id
      this.cnRec.amount = rec.amount
      this.cnRec.description = rec.description
      this.cnRec.contract_id = rec.contract_id
      this.cnRec.year = rec.year
      this.cnRec.semester = rec.semester
      this.cnRec.number = 'CN-' + rec.number
      if (rec.document_type_id === 1) {
        this.cnRec.document_type_id = 2
      }
      if (rec.document_type_id === 5) {
        this.cnRec.document_type_id = 6
      }
      if (rec.document_type_id === 7) {
        this.cnRec.document_type_id = 8
      }
      if (rec.document_type_id === 9) {
        this.cnRec.document_type_id = 10
      }
      this.$refs.modalCreditNote.show()
    },
    okCreditNote () {
      let rec = {}
      Object.assign(rec, this.cnRec)
      api.post(this.tableCfg.detailApiUrl, rec,
      data => {
        // console.log('post result ' + this.tableCfg.detailApiUrl + rec.id, data)
        this.$router.push({ name: 'creditnote_invoice', params: {id: data.id} })
      },
      'creating credit note', this.$refs.layout.$refs.alert)
    },
    linkRegistrationFee (rec) {
      this.lrfRec['invoice_id'] = rec.id
      this.$refs.lfrOptionList.updateOptionsParams({'contract_id': rec.contract_id, 'document_type_id': 3})
      this.$refs.modalLinkRegistrationFee.show()
    },
    okLinkRegistrationFee () {
      // console.log('okLinkRegistrationFee', this.lrfRec)
      api.post('/invoices/' + this.lrfRec.invoice_id + '/link_registration_id', {'registration_fee_id': this.lrfRec.registration_id},
      data => { },
      'linking registration fee', this.$refs.layout.$refs.alert)
    }
  }
}
</script>



// WEBPACK FOOTER //
// Detail.vue?580173a7